import { getAddressKey } from '@cowprotocol/cow-sdk'
import { TokensByAddress } from '@cowprotocol/tokens'

import { Order, OrderStatus } from 'legacy/state/orders/actions'

import { TwapOrderItem, TwapOrderStatus } from 'modules/twap'

import { emulateTwapAsOrder } from './emulateTwapAsOrder'

import { isEoaTwapOrderItem } from '../utils/isEoaTwapOrderItem'

const statusesMap: Record<TwapOrderStatus, OrderStatus> = {
  [TwapOrderStatus.Cancelled]: OrderStatus.CANCELLED,
  [TwapOrderStatus.Expired]: OrderStatus.EXPIRED,
  [TwapOrderStatus.PartiallyFilled]: OrderStatus.FULFILLED,
  [TwapOrderStatus.Pending]: OrderStatus.PENDING,
  [TwapOrderStatus.WaitSigning]: OrderStatus.PRESIGNATURE_PENDING,
  [TwapOrderStatus.Fulfilled]: OrderStatus.FULFILLED,
  [TwapOrderStatus.Cancelling]: OrderStatus.PENDING,
}

export function mapTwapOrderToStoreOrder(order: TwapOrderItem, tokensByAddress: TokensByAddress): Order | null {
  const enrichedOrder = emulateTwapAsOrder(order)
  const status = statusesMap[order.status]
  const inputToken = tokensByAddress[getAddressKey(enrichedOrder.sellToken)]
  const outputToken = tokensByAddress[getAddressKey(enrichedOrder.buyToken)]

  if (!inputToken || !outputToken) return null

  return {
    ...enrichedOrder,
    id: enrichedOrder.uid,
    composableCowInfo: {
      id: order.id,
      twapOrderHash: order.hash,
    },
    sellAmountBeforeFee: enrichedOrder.sellAmount,
    inputToken,
    outputToken,
    creationTime: enrichedOrder.creationDate,
    status,
    apiAdditionalInfo: enrichedOrder,
    isCancelling: order.status === TwapOrderStatus.Cancelling,
    isEoaTwapOrder: isEoaTwapOrderItem(order),
  }
}
